import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  CardTitle,
  CardText,
  CardImg
} from "reactstrap";
import "./index.scss";
/* import icon_apple_store from "../../assets/images/icon_apple_store.png";
import icon_google_store from "../../assets/images/icon_google_play.png";
const default_type = [{ value: "", label: "Todos" }]; */
class VistaTutoriales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false
    };
  }
  componentDidMount() {}
  render() {
    return (
      <div>
        <Row className="no-gutters">
          <Col>
            <Card className="header-toolbar-menu">
              <CardBody className="text-center">
                <span className="text-white  header-toolbar-menu-text-size">
                  Guía para la administración de contenidos en los aplicativos
                  web de los Sistemas de Información Ambiental
                </span>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <CardBody>
                    <CardTitle>
                      <p className="text-primary font-weight-bold h4">
                        Enlaces web
                      </p>
                    </CardTitle>
                    <CardText>
                        <a
                          href={"http://sinia.minam.gob.pe/Gu%C3%ADa_part1"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          I. Introducción a los Sistemas de Información
                          Ambiental.
                        </a>
                    </CardText>
                    <CardText>
                        <a
                          href={"http://sinia.minam.gob.pe/adminSIA"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          II. Administración del Sistema de Información
                          Ambiental.
                        </a>
                    </CardText>
                    <CardText>
                        <a
                          href={"http://sinia.minam.gob.pe/Acceso_al_SIA"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          III. Acceso al Sistema de Información Ambiental SIAR,
                          SIAL.
                        </a>
                    </CardText>
                    <CardText>
                        <a
                          href={
                            "http://sinia.minam.gob.pe/Configuraciones_iniciales"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          IV. Configuraciones iniciales del Sistema de
                          Información Ambiental.
                        </a>
                    </CardText>
                    <CardText>
                        <a
                          href={"http://sinia.minam.gob.pe/Interfaz"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          V. Interfaz de la gestión principal de contenidos.
                        </a>
                    </CardText>
                    <CardText>
                        <a
                          href={
                            "http://sinia.minam.gob.pe/Gestion_de_contenidos"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          VI. Gestión de contenidos.
                        </a>
                    </CardText>
                    <CardText>
                        <a
                          href={
                            "http://sinia.minam.gob.pe/Gestion_de_servicios"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          VII. Gestión de servicios.
                        </a>
                    </CardText>
                    <CardText>
                        <a
                          href={"http://sinia.minam.gob.pe/Videos_tutoriales"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          VIII. Videos tutoriales.
                        </a>
                    </CardText>
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default VistaTutoriales;
